<template>
  <div class="has-background-white generic-settings">
    <div class="account-tabs-header has-background-black-bis is-flex is-justify-content-space-between is-align-items-center">
      <div class="tabs-nav">
        <button v-for="tab in visibleTabs" :key="tab.key" class="tab-btn"
          :class="{ 'is-active': activeTab === tab.key }" @click="activeTab = tab.key">
          {{ tab.label }}
        </button>
      </div>
    </div>
    <div class="column">
      <div class="columns">
        <div class="column has-text-right">
          <button class="button p-0 has-text-black-bis mr-2" @click="isActivityOpen = true">
            <i class="icon-activityhistory"></i>
          </button>
        <activity-slider
          :isActive="isActivityOpen"
          :id="user._id"
          module="User"
          type="accountSetting"
          :company="user.company"
          @update:isActive="isActivityOpen = false">
        </activity-slider>
        </div>
      </div>
    </div>
    <div class="integration-tab" v-if="activeTab === 'general'">
      <div class="column">
        <div class="columns">
          <div class="column is-4">
            <div class="has-background-grey-lighter p-2 display-pic">
              <h2
                class="is-size-2 has-text-weight-bold has-text-black-bis mb-5 is-flex is-flex-direction-row is-justify-content-space-between">
                <span>Personal Settings</span>
                <div>
                  <div class="buttons" v-if="generalSettings.editPersonalInfo">
                    <button class="button is-outlined mr-2 p-0" @click="actionClicked('cancel', 'editPersonalInfo')">
                      <i class="icon-close"></i>
                    </button>
                    <button class="button is-success has-text-white p-0"
                      @click="actionClicked('save', 'editPersonalInfo')">
                      <i class="icon-checkmark has-text-white"></i>
                    </button>
                  </div>
                  <button v-else class="button has-text-black-bis is-medium p-0" :disabled="isTabsDisabled"
                    @click="actionClicked(true, 'editPersonalInfo')">
                    <i class="icon-edit"></i></button>
                </div>
              </h2>
              <div class="columns">
                <div class="column is-narrow pr-0"><i class="icon-genericuserfull has-text-black-bis"></i></div>
                <div class="column">
                  <input class="input generic-input" v-model="user.firstName"
                    :disabled="!generalSettings.editPersonalInfo" />
                </div>
                <div class="column">
                  <input class="input generic-input" v-model="user.lastName"
                    :disabled="!generalSettings.editPersonalInfo" />
                </div>
              </div>
              <div class="columns">
                <div class="column is-narrow pr-0"><i class="icon-email has-text-black-bis"></i></div>
                <div class="column">
                  <input class="input generic-input" v-model="user.email" placeholder="Email" :disabled="!generalSettings.editPersonalInfo"/>
                </div>
              </div>
              <div class="columns">
                <div class="column is-narrow pr-0"><i class="icon-phone is-size-1 has-text-black-bis"></i></div>
                <div class="column">
                  <input class="input generic-input" v-model="user.officePhone" placeholder="Office Number" :disabled="!generalSettings.editPersonalInfo"/>
                </div>
              </div>
              <div class="columns">
                <div class="column is-narrow pr-0"><i class="icon-mobile is-size-1 has-text-black-bis"></i></div>
                <div class="column">
                  <input class="input generic-input" v-model="user.mobilePhone" placeholder="Mobile Number" :disabled="!generalSettings.editPersonalInfo"/>
                </div>
              </div>
            </div>
          </div>
          <div class="column ">
            <div class="has-background-grey-lighter p-2 display-pic">
              <div class="columns">
                <div class="column">
                  <h2
                    class="is-size-2 has-text-weight-bold has-text-black-bis mb-5 is-flex is-flex-direction-row is-justify-content-space-between">
                    <span>Display Picture</span>
                    <div class="is-flex is-justify-content-flex-end">
                      <div v-if="generalSettings.editDisplayPicture">
                        <button class="button  is-medium is-outlined mr-2 p-0"
                          @click="actionClicked('cancel', 'editDisplayPicture')">
                          <i class="icon-close"></i>
                        </button>
                        <button class="button is-success has-text-white p-0"
                          @click="actionClicked('save', 'editDisplayPicture')">
                          <i class="icon-checkmark has-text-white"></i>
                        </button>
                      </div>
                      <button v-else class="button has-text-black-bis is-medium p-0" :disabled="isTabsDisabled"
                        @click="actionClicked(true, 'editDisplayPicture')">
                        <i class="icon-edit"></i>
                      </button>
                    </div>
                  </h2>
                  <div class="display-img has-text-centered">
                    <img v-if="profileUrl" :src="profileUrl" class="mb-2" />
                    <i v-else class="icon-genericuserfull has-text-black-bis"></i>
                  </div>
                  <div v-if="generalSettings.editDisplayPicture">
                    <button class="buttons is-centered is-flex is-align-items-center is-justify-content-center mt-2 group-button is-borderless">
                      <button class="button has-background-black-bis has-text-white"
                        @click="removeImage('imageUrl')">Delete</button>
                      <mf-file-picker accept="image/png, image/jpeg" :path="'users/addAvatar'" :filePath="'imageUrl'"
                        :multiple="false" :hideLimitText="true" :isImageUpload="true" @onInput="(file) => handleAvatarUpload(file, 'imageUrl')">Upload
                        Image</mf-file-picker>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="has-background-grey-lighter p-2 display-pic">
              <div class="columns">
                <div class="column">
                  <h2
                    class="is-size-2 has-text-weight-bold has-text-black-bis mb-5 is-flex is-flex-direction-row is-justify-content-space-between">
                    <span>Signature</span>
                    <div class="is-flex is-justify-content-flex-end">
                      <div v-if="generalSettings.editSignature">
                        <button class="button is-outlined p-0 mr-2"
                          @click="actionClicked('cancel', 'editSignature')">
                          <i class="icon-close"></i>
                        </button>
                        <button class="button is-success has-text-white p-0"
                          @click="actionClicked('save', 'editSignature')">
                          <i class="icon-checkmark has-text-white"></i>
                        </button>
                      </div>
                      <button v-else class="button p-0 is-medium has-text-black-bis" :disabled="isTabsDisabled"
                        @click="actionClicked(true, 'editSignature')">
                        <i class="icon-edit"></i>
                      </button>
                    </div>
                  </h2>
                  <div class="display-img has-text-centered">
                    <img v-if="signatureUrl" :src="signatureUrl" />
                    <i v-else class="icon-genericuserfull has-text-black-bis"></i>
                  </div>
                  <template v-if="generalSettings.editSignature">
                    <div class="buttons is-flex is-align-items-center mt-2 is-justify-content-center group-button is-borderless mb-0">
                      <button class="button has-background-black-bis has-text-white is-medium"
                        @click="removeImage('signatureUrl')">Delete
                      </button>
                      <mf-file-picker accept="image/png, image/jpeg" :path="'users/addAvatar'"
                        :filePath="'imageUrl'" :isImageUpload="true" :multiple="false" :hideLimitText="true"
                        @onInput="(file) => handleAvatarUpload(file, 'signatureUrl')">Upload Image</mf-file-picker>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="has-background-grey-lighter p-2 display-pic">
              <div>
                <h2
                  class="is-size-2 has-text-weight-bold has-text-black-bis mb-5 is-flex is-flex-direction-row is-justify-content-space-between">
                  <span>Password Settings</span>
                  <div class="is-justify-content-flex-end is-flex">
                    <template v-if="generalSettings.editPasswordInfo">
                      <button class="button is-outlined p-0 mr-2" @click="actionClicked('cancel', 'editPasswordInfo')">
                        <i class="icon-close"></i>
                      </button>
                      <button class="button is-success has-text-white p-0"
                        @click="actionClicked('save', 'editPasswordInfo')">
                        <i class="icon-checkmark has-text-white"></i>
                      </button>
                    </template>
                    <button v-else type="button" class="button has-text-black-bis is-medium p-0"
                      :disabled="viewOnlyMemberDisabled" @click="actionClicked(true, 'editPasswordInfo')">
                      <i class="icon-edit"></i>
                    </button>
                  </div>
                </h2>
                <input type="password" placeholder="Old Password" name="password-old" autocomplete="new-password"
                  class="input mb-4" v-model="password.oldPassword" :disabled="!generalSettings.editPasswordInfo" />
                <input type="password" placeholder="New Password" name="password-new" autocomplete="new-password"
                  class="input mb-4" v-model="password.newPassword" :disabled="!generalSettings.editPasswordInfo" />
                <input type="password" placeholder="Confirm Password" name="password-confirm"
                  autocomplete="new-password" class="input mb-4" v-model="password.confirmPassword"
                  :disabled="!generalSettings.editPasswordInfo" />
              </div>
            </div>
          </div>
        </div>
        <div class="is-divider"></div>
        <div class="columns">
          <div class="column is-4">
            <div class="has-background-grey-lighter p-2">
              <div class="columns is-multiline">
                <div class="column is-12">
                  <h2 class="is-size-2 has-text-weight-bold has-text-black-bis mb-5 is-flex is-flex-direction-row is-justify-content-space-between">
                    <span>Navigation Preferences</span>
                      <div class="is-justify-content-flex-end is-flex">
                      <template v-if="editAccountSettings.editNavigation">
                        <button class="button is-outlined p-0 mr-2"
                          @click="actionClicked('cancel', 'editNavigation')">
                          <i class="icon-close"></i>
                        </button>
                        <button class="button is-success has-text-white p-0"
                          @click="actionClicked('save', 'editNavigation')">
                        <i class="icon-checkmark has-text-white"></i>
                        </button>
                      </template>
                      <button v-else class="button has-text-black-bis is-medium p-0"
                        @click="actionClicked(true, 'editNavigation')">
                      <i class="icon-edit"></i>
                      </button>
                    </div>
                  
                  </h2>
                  <h3 class="is-size-3 has-text-weight-semibold has-text-black-bis mb-3">When I edit orders</h3>
                  <mf-multi-select v-if="editAccountSettings.editNavigation" v-model="openPreference"
                    :options="userPreferences" :closeOnSelect="true" label="name" track-by="value" :allow-empty="false"
                    :multiple="false" deselect-label select-label @update:modelValue="changeUserPreference()"
                    class="pendo-orderEdit-navigation-select" />
                  <h5 class="is-size-5 has-text-weight-semibold has-text-grey  line-height" v-else>{{
                    openPreference.name
                  }}
                  </h5>
                </div>
                <div class="column is-12">
                  <h3 class="is-size-3 has-text-weight-semibold has-text-black-bis mb-3">When I Login Take me To</h3>
                  <mf-multi-select v-if="editAccountSettings.editNavigation" v-model="defaultLanding"
                    :options="defaultLandingOptions" :closeOnSelect="true" label="name" track-by="code"
                    :allow-empty="false" :multiple="false" deselect-label select-label
                    @update:modelValue="changeDefaultLanding()" class="pendo-login-navigation-select" />
                  <h5 class="is-size-5 has-text-weight-semibold has-text-grey line-height" v-else>{{ defaultLanding.name
                  }}</h5>
                </div>
                <div class="column is-12">
                  <h3 class="is-size-3 has-text-weight-semibold has-text-black-bis mb-5">My Project Filters</h3>
                  <div v-if="editAccountSettings.editNavigation" class="has-text-black-bis">
                    <p class="is-size-4  has-text-black-bis mb-3 is-flex is-align-items-center">
                      <input type="radio" class="mr-2"  value="lastUsed" v-model="defaultProjectSelection" @change="setDefaultSelection"/>
                       <span>Use Traditional Project Filtering</span>
                    </p>
                    <p class="is-size-4 has-text-black-bis mb-3 is-flex is-align-items-center">
                      <input type="radio"  class="mr-2" value="frequentlyUsed"  v-model="defaultProjectSelection" @change="setDefaultSelection"/>
                      <span>Show Frequently Used Projects</span>
                    </p>
                  </div>
                  <h5 class="is-size-5 has-text-weight-semibold has-text-grey line-height" v-else>
                    {{ user.rememberLastUsedProjects ? 'Last Used Projects' : 'on/off Frequently Used Projects' }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="column" v-if="user._id">
            <div class="has-background-grey-lighter p-4">
              <h2 class="is-size-2 has-text-weight-bold has-text-black-bis mb-3 is-flex is-flex-direction-row is-justify-content-space-between">
                <span>Notifications</span>
                  <div class="is-flex is-justify-content-flex-end">
                    <template v-if="editAccountSettings.editNotifications">
                      <button class="button is-outlined p-0 mr-2"
                        @click="actionClicked('cancel', 'editNotifications')">
                        <i class="icon-close"></i>                      
                      </button>
                      <button class="button is-success has-text-white p-0"
                        @click="actionClicked('save', 'editNotifications')">
                        <i class="icon-checkmark has-text-white"></i>                      
                      </button>
                    </template>
                    <button v-else class="button has-text-black-bis is-medium p-0"
                      @click="actionClicked(true, 'editNotifications')">
                    <i class="icon-edit"></i>
                  </button>
                  </div>
              </h2>
              <div class="columns">
                <div class="column">
                  <h3 class="is-size-3 has-text-weight-semibold line-height has-text-black-bis mb-3">
                    Notify me when a project I'm on
                  </h3>
                  <div class="is-flex is-align-items-center has-text-black-bis">
                    <o-checkbox v-if="editAccountSettings.editNotifications"
                      v-model="user.subscribeForNotify.memberNotify" />
                    <i v-else
                      :class="user.subscribeForNotify.memberNotify
                        ? 'icon-checkmark has-text-success has-text-weight-bold' : 'icon-close has-text-danger mr-4'"></i>
                    <span class="is-size-3">Has a team member added to or removed from
                      Project</span>
                  </div>
                </div>
                <div class="column">
                  <h3 class="is-size-3 has-text-weight-semibold line-height has-text-black-bis mb-3 line-height">Email
                    Notifications
                  </h3>
                  <div class="is-flex is-align-items-center has-text-black-bis">
                    <o-checkbox v-if="editAccountSettings.editNotifications" v-model="user.isEmailPush" />
                    <i v-else :class="user.isEmailPush
                      ? 'icon-checkmark has-text-success has-text-weight-bold ' : 'icon-close has-text-danger mr-4'"
                      class="line-height"></i>
                    <span class="is-size-3">Send individual emails</span>
                  </div>

                </div>
                <div class="column">
                  <div class="is-flex is-align-items-center mb-3">
                    <o-checkbox v-if="editAccountSettings.editNotifications"
                      v-model="user.subscribeForNotify.companyNotify" />
                    <i v-else :class="user.subscribeForNotify.companyNotify
                      ? 'icon-checkmark has-text-success' : 'icon-close has-text-danger mr-4'"></i>
                    <span class="is-size-3 has-text-black-bis">Has a member added to or removed from Company</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="is-divider my-3"></div>
            <div class="columns">
              <div class="column">
                <div class="has-background-grey-lighter p-3">
                  <h4 class="is-size-5 has-text-weight-semibold mb-3 has-text-black-bis">Manage Subscriptions</h4>
                  <button class="button has-text-white has-background-black-bis is-size-3"
                    @click="manageSubscription()">
                    Select Projects...
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div v-if="activeTab === 'integrations'" class=" has-text-black-bis integration-tab">
      <!-- <div v-if="!hasIntegrationsPermission" class="no-permission-msg has-text-black-bis">
        <i class="icon-lockprivate is-size-1"></i>
        <p>You do not have permission to view Integrations.</p>
      </div> -->
      <div class="column">
        <div class="columns">
          <div class="column">
            <div class="has-background-grey-lighter p-2">
              <bim-plus-user />
            </div>
          </div>
          <div class="column">
            <div class="has-background-grey-lighter p-2">
              <forge-user />
            </div>
          </div>
          <div class="column">
            <div class="has-background-grey-lighter p-2">
              <procore-user />
            </div>
          </div>
        </div>
      </div>
    </div>
    <o-modal :active="showSubscriptionModal" :canCancel="false">
      <manage-subscription @close="showSubscriptionModal = false" />
    </o-modal>
  </div>
</template>

<script>
import { computed, onMounted, reactive, toRefs } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { cloneDeep, find, isEmpty, get, } from 'lodash';
import Users from '@/models/Users';
import s3FileAccess from '@/models/SimpleStorageService';
import { useToast } from 'vue-toastification';
import { DialogProgrammatic } from '@/components/Dialog';
import PermissionMixin from '@/components/mixins/PermissionMixin';
import Validation from '@/utils/Validations'
import ForgeUser from './ForgeUser.vue';
import ProcoreUser from './ProcoreUser.vue';
import BimPlusUser from './BimPlusUser.vue';
import ManageSubscription from './ManageSubscription.vue';
import MfFilePicker from '@/components/MfFilePicker.vue';
import ActivitySlider from '@/components/ActivitySlider.vue';


export default ({
  name: 'AccountSettings',
  components: {
    'forge-user': ForgeUser,
    'procore-user': ProcoreUser,
    'bim-plus-user': BimPlusUser,
    'manage-subscription': ManageSubscription,
    'mf-file-picker': MfFilePicker,
    'activity-slider': ActivitySlider,
  },
  setup() {
    const { getPermissionValues } = PermissionMixin();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const toast = useToast();
    const data = reactive({
      user: {
        firstName: '',
        lastName: '',
        email: '',
        officePhone: '',
        mobilePhone: '',
        imageUrl: { fileGuid: '' },
        signatureUrl: { fileGuid: '' },
      },
      oldUser: {
        firstName: '',
        lastName: '',
        email: '',
        officePhone: '',
        mobilePhone: '',
        imageUrl: { fileGuid: '' },
        signatureUrl: { fileGuid: '' },
      },
      profileUrl: '',
      signatureUrl: '',
      password: { oldPassword: '', newPassword: '', confirmPassword: '' },
      activeTab: 'general',
      isActivityOpen: false,
      showSubscriptionModal: false,
      openPreference: '',
      defaultLanding: '',
      defaultProjectSelection: '',
      calendarUrl: '',
      generalSettings: {
        editPersonalInfo: false,
        editDisplayPicture: false,
        editPasswordInfo: false,
        editSignature: false,
      },
      editAccountSettings: {
        editNavigation: false,
        editNotifications: false,
      },
    });
    const tabs = [
      { key: 'general', label: 'General Settings' },
      { key: 'integrations', label: 'Integrations', permissionModule: 'app&projects', permissionType: 'thirdPartyPlugins' },
    ];
    const defaultLandingOptions = [
      { name: 'Home', code: 'home', path: '/home' },
      { name: 'Material Manager', code: 'mm', path: '/materials/preparation' },
      { name: 'Prefab Planner', code: 'prefabs', path: '/prefabs-list' },
      { name: 'Schedule', code: 'schedules', path: '/schedule-list' },
      { name: 'Production Manager', code: 'pm', path: '/manager/detailing' },
      { name: 'Supply Chain Manager', code: 'scm', path: '/scm/production-status/order-view' },
    ];
    const userPreferences = [
      { name: 'Open them in a new tab', value: 'newTab' },
      { name: 'Open them in a same tab', value: 'sameTab' },
    ];
    const hasIntegrationsPermission = computed(() => !getPermissionValues({
      permissionModule: 'app&projects',
      type: 'thirdPartyPlugins',
    }));

    const visibleTabs = computed(() => tabs.filter((tab) => {
      if (tab.permissionModule) {
        return store.getters.hasCompanyPermissionForModule('app&projects:plugins');
      }
      return true;
    }));

    const isGeneralEdit = computed(() =>
      data.generalSettings.editPersonalInfo ||
      data.generalSettings.editDisplayPicture ||
      data.generalSettings.editPasswordInfo ||
      data.generalSettings.editSignature
    );

    const isTabsDisabled = computed(() => isGeneralEdit.value);

    const viewOnlyMemberDisabled = computed(() =>
      isGeneralEdit.value || store.state.userData.viewOnlyMember
    );

    const setOtherFields = async () => {
      data.openPreference = find(userPreferences, (p) => p.value === data.user.openPreference)
        || userPreferences[0];
      data.defaultLanding = find(defaultLandingOptions, (l) => l.code === data.user.defaultLanding)
        || defaultLandingOptions[0];
      data.defaultProjectSelection = data.user.rememberLastUsedProjects ? 'lastUsed' : 'frequentlyUsed';
    };

    const loadAvatarUrls = async () => {
      const fileGuid = get(data.user, 'imageUrl.fileGuid');
      if (data.user._id && fileGuid !== '') {
        const { presignedUrl } = await s3FileAccess.getS3File({ type: 'user', id: fileGuid });
        data.profileUrl = presignedUrl || '';
      } else {
        data.profileUrl = '';
      }
      const sigGuid = get(data.user, 'signatureUrl.fileGuid', '');
      if (data.user._id && sigGuid !== '') {
        const { presignedUrl } = await s3FileAccess.getS3File({ type: 'user', id: sigGuid });
        data.signatureUrl = presignedUrl || '';
      } else {
        data.signatureUrl = '';
      }
    };

    const reset = async () => {
      Object.assign(data.user, cloneDeep(data.oldUser));
      await setOtherFields();
      await loadAvatarUrls();
    };

    const removeImage = (type = 'imageUrl') => {
      data.user[type] = { fileGuid: '' };
      if (type === 'imageUrl') {
        data.profileUrl = '';
      } else {
        data.signatureUrl = '';
      }
    };

    const handleAvatarUpload = async (file, type) => {
      data.user[type] = file;
      const fileGuid = get(file, 'fileGuid', '');
      if (fileGuid) {
        const { presignedUrl } = await s3FileAccess.getS3File({
          type: 'user',
          id: fileGuid,
        });
        if (type === 'imageUrl') {
          data.profileUrl = presignedUrl || '';
        } else {
          data.signatureUrl = presignedUrl || '';
        }
      }
    };

    const validatePasswordReset = () => {
      const { oldPassword, newPassword, confirmPassword } = data.password;
      if (isEmpty(oldPassword)) {
        return { changed: true, validated: false, error: 'Please enter the Old Password' };
      }
      if (isEmpty(newPassword) || isEmpty(confirmPassword)) {
        return { changed: true, validated: false, error: 'Please fill in all password fields' };
      }
      if (newPassword !== confirmPassword) {
        return { changed: true, validated: false, error: 'New Password and confirmation do not match' };
      }
      return { changed: true, validated: true };
    };
    const validateUserDetails = () => {
      if (!data.user.firstName || !data.user.lastName) {
        toast.error('First and last names are mandatory');
        return false;
      }
      const { officePhone } = data.user;
      if (!isEmpty(officePhone) && !Validation.validatePhoneNumber(officePhone, false)) {
        toast.error('Valid range for phone number length is 1 - 24!');
        return false;
      }
      const { mobilePhone } = data.user;
      if (!isEmpty(mobilePhone) && !Validation.validatePhoneNumber(mobilePhone, false)) {
        toast.error('Valid range for phone number length is 1 - 24!');
        return false;
      }
      return true;
    };

    const setLandingPage = (resetPasswordResponse) => {
      const landing = find(defaultLandingOptions, { code: resetPasswordResponse.defaultLanding });
      if (landing) localStorage.setItem('landingPage', landing.path);
    };

    const logout = async () => {
      await Users.logout();
      router.push({ path: '/login' });
    };

    const updateAccount = async (section) => {
      if (!validateUserDetails()) {
        data.generalSettings.editPersonalInfo = true;
        return;
      }

      const userValues = [
        '_id', 'firstName', 'lastName', 'openPreference', 'defaultLanding',
        'officePhone', 'mobilePhone', 'overDueBatch1', 'overDueBatch2',
        'isEmailPush', 'subscribeForNotify', 'rememberLastUsedProjects',
      ];

      const updatedUser = Object.fromEntries(
        userValues.filter((k) => data.user[k] !== undefined).map((k) => [k, data.user[k]])
      );

      if (isEmpty(get(data.oldUser, 'officePhone', '')) && isEmpty(updatedUser.officePhone)) {
        delete updatedUser.officePhone;
      }
      if (isEmpty(get(data.oldUser, 'mobilePhone', '')) && isEmpty(updatedUser.mobilePhone)) {
        delete updatedUser.mobilePhone;
      }

      try {
        await Users.updateAccount(updatedUser, data.user.imageUrl, data.user.signatureUrl);
        store.dispatch('getUserData');
        setLandingPage(updatedUser);
        toast.success('Account updated successfully');
      } catch {
        toast.error('Please check the values');
        return;
      }

      const passwordReset = validatePasswordReset();
      if (passwordReset.changed && passwordReset.validated) {
        try {
          const resetPasswordResponse = await Users.resetPassword(data.password, { _id: data.user._id });
          localStorage.setItem('auth-token', resetPasswordResponse.token);
          toast.success('Account updated, password changed successfully');
          router.push('/login');
        } catch (err) {
          toast.error(err?.data?.message || 'Password reset failed');
        }
      }
      Object.assign(data.oldUser, cloneDeep(data.user));
    };

    const actionClicked = async (value, section) => {
      if (value === 'save') {
        if (section === 'editPasswordInfo') {
          const passwordReset = validatePasswordReset();
          if (passwordReset.changed && !passwordReset.validated) {
            if (isEmpty(data.password.oldPassword)) {
              toast.error('Please enter the Old Password');
            } else if (data.password.newPassword !== data.password.confirmPassword) {
              toast.error('New Password and confirmation do not match');
            }
            data.generalSettings.editPasswordInfo = true;
            return;
          }          
          DialogProgrammatic.confirm({
            title: 'Warning',
            message: 'Setting this password will update the licensing password used across other ALLPLAN products, such as SDS2.',
            type: 'warning',
            okButton: 'Ok',
            onConfirm: async () => {
              data.generalSettings.editPasswordInfo = false;
              await updateAccount(section);
            },
          });
          return;
        }
        Object.keys(data.generalSettings).forEach((k) => { data.generalSettings[k] = false; });
        Object.keys(data.editAccountSettings).forEach((k) => { data.editAccountSettings[k] = false; });
        await updateAccount(section);
        if (section === 'editNavigation') {
          toast.warning('Please log back in for the new settings to apply!');
          await logout();
        }
      } else if (value === 'cancel') {
        await reset();
        data.password = { oldPassword: '', newPassword: '', confirmPassword: '' };
        if (section in data.generalSettings) data.generalSettings[section] = false;
        else data.editAccountSettings[section] = false;
      } else {
        // edit clicked
        if (section in data.generalSettings) {
          data.generalSettings[section] = value;
          data.editAccountSettings.editNavigation = false;
          data.editAccountSettings.editNotifications = false;
          Object.keys(data.generalSettings).filter((k) => k !== section).forEach((k) => {
            data.generalSettings[k] = false;
          });
        } else {
          data.editAccountSettings[section] = value;
          data.password = { oldPassword: '', newPassword: '', confirmPassword: '' };
        }
      }
    };

    const changeUserPreference = () => {
      data.user.openPreference = data.openPreference.value;
    };

    const changeDefaultLanding = () => {
      data.user.defaultLanding = data.defaultLanding.code;
    };

    const setDefaultSelection = () => {
      data.user.rememberLastUsedProjects = data.defaultProjectSelection === 'lastUsed';
    };

    const manageSubscription = () => {
      data.showSubscriptionModal = true;
    };



    onMounted(async () => {
      if (route.params && route.params.refreshToken) {
        data.activeTab = 'integrations';
      }
      await store.getters.userPromise;
      Object.assign(data.user, cloneDeep(store.state.userData));
      Object.assign(data.oldUser, cloneDeep(store.state.userData));
      await setOtherFields();
      await loadAvatarUrls();
    });

    return {
      ...toRefs(data),
      tabs,
      visibleTabs,
      defaultLandingOptions,
      userPreferences,
      isTabsDisabled,
      viewOnlyMemberDisabled,
      hasIntegrationsPermission,
      removeImage,
      actionClicked,
      changeUserPreference,
      changeDefaultLanding,
      setDefaultSelection,
      manageSubscription,
      handleAvatarUpload,
    };
  },
});
</script>